import { ca } from '@cian/analytics';

import { getDeveloperContactsLabel } from '../../serp/components/header/developers_contacts';

type TNewbuildingComparisonAction = 'Add' | 'Remove' | 'click_popup_add' | 'click_popup_remove';

function trackNewbuildingComparisonEvent(newbuildingId: number, action: TNewbuildingComparisonAction, label: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CompareJK',
    action,
    label,
    products: [
      {
        id: newbuildingId,
        offerType: 'JK',
      },
    ],
  });
}

export function trackAddNewbuildingToComparison(newbuildingId: number) {
  trackNewbuildingComparisonEvent(newbuildingId, 'Add', getDeveloperContactsLabel(null));
}

export function trackRemoveNewbuildingFromComparison(newbuildingId: number) {
  trackNewbuildingComparisonEvent(newbuildingId, 'Remove', getDeveloperContactsLabel(null));
}

export function trackClickAddComparisonPopup(newbuildingId: number) {
  trackNewbuildingComparisonEvent(newbuildingId, 'click_popup_add', 'to_compare');
}

export function trackClickRemoveComparisonPopup(newbuildingId: number) {
  trackNewbuildingComparisonEvent(newbuildingId, 'click_popup_remove', 'to_compare');
}
